import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { extendedTestimonials } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-cream" data-id="element-67" data-mp="bjmfuaxnuwpf">
      <div className="max-w-6xl mx-auto" data-id="element-68" data-mp="bithnycrpfiw">
        <div className="text-center mb-16" data-id="element-69" data-mp="gal1zr5byp0l">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-charcoal" data-id="element-70" data-mp="gcfm538s2d3m">
            What Massage Therapists Are Saying
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-71" data-mp="q8ixmzpiro38">
          {extendedTestimonials.map((t, i) => <motion.figure key={t.role} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-paper border border-warmgray p-8 rounded-2xl relative flex flex-col h-full" data-id="element-72" data-mp="ubp15zl8z160" data-mpi={i}>
              <Quote className="absolute top-6 right-6 text-terracotta/15" size={48} aria-hidden="true" data-id="element-73" data-mp="33y1bi2b3xdgh" />

              <div className="flex gap-1 text-burnt mb-6" aria-label="5 out of 5 stars" data-id="element-74" data-mp="3vq0c51z714fg">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" aria-hidden="true" data-id="element-75" data-mp="3rmkimeif7k6z" data-mpi={j} />)}
              </div>

              <blockquote className="text-charcoal-soft italic mb-8 relative z-10 leading-relaxed flex-grow" data-id="element-76" data-mp="2b9vota0htee0">
                "{t.text}"
              </blockquote>

              <figcaption className="flex items-center gap-4 mt-auto" data-id="element-77" data-mp="269r75gnumdm7">
                <div className="w-12 h-12 rounded-full bg-terracotta text-paper flex items-center justify-center font-bold text-lg shrink-0" data-id="element-78" data-mp="27tampk11yejt">
                  {t.initials}
                </div>
                <div data-id="element-79" data-mp="1yqhyjpn62iy7">
                  <div className="font-bold text-charcoal" data-id="element-80" data-mp="1yr1j7e47blfx">{t.name}</div>
                  <div className="text-xs text-terracotta-dark" data-id="element-81" data-mp="23pl3la35cp66">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}